/**
 *
 * ResetPassword validation
 *
 * */

import { IntlShape } from 'react-intl';

import globalMessages from 'src/messages/global.messages';

export const validate = (intl: IntlShape) => (values: any) => {
  const errors: any = {};

  switch (true) {
    case !values.email:
      errors.email = intl.formatMessage(globalMessages.notValidEmail);
      break;

    case !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email):
      errors.email = intl.formatMessage(globalMessages.required);
      break;

    default:
  }

  return errors;
};

export default validate;
